module.exports = __webpack_public_path__ + "d2987e86d197d2fe2c4675ee5ceb6ff9.svg";